import {useAwardBanner, useFooter, useLanguage, useMainScrolling, useUserAgent} from "../../hooks/hooks";
import React, {useEffect} from "react";
import {MainArticle1} from "./MainArticle1";
import {FloatingBtn} from "../common/button/FloatingBtn";
import {MainArticle2} from "./MainArticle2";
import {MainArticle3} from "./MainArticle3";
import {MainArticle4} from "./MainArticle4";
import style from "./main.module.scss";
import {Popups} from "./popup/Popups";
import {BrandSection} from "./bradning/BrandSection";
import {MainPartnership} from "./partnership/MainPartnership";

export function Main() {
  const { headerHeight } = useMainScrolling();
  const { setShowFooter } = useFooter();
  const { isDesktop, isTablet } = useUserAgent();
  const { hideAwardBanner } = useAwardBanner();
  const { isKorean } = useLanguage();
  const isBannerVisible = isDesktop && isKorean && !hideAwardBanner;

  // 영문 시 로그인바 미노출로 인한 높이 차이 해결로 임시 사용
  const loginBarAdditionalTabletHeight = (isTablet && !isKorean) ? -43 : 0;

  useEffect(() => {
    window.scrollTo(0, 0);
    setShowFooter(true);
    document.title = `${process.env.REACT_APP_TITLE}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
  }, [hideAwardBanner]);

  const headerAdditionalHeight = isDesktop ? -10 : isTablet ? 128 + loginBarAdditionalTabletHeight : -1;

  return (
    <main
        className={`${style.main} ${isBannerVisible ? style.mainBanner : ""}`}
        style={{ marginTop: `${isDesktop 
              ? headerHeight + headerAdditionalHeight
              : -10 + headerAdditionalHeight}px`, letterSpacing: "-0.015em" }}
    >
      <Popups />
      <BrandSection />
      <MainPartnership />
      <MainArticle1 />
      <MainArticle2 />
      <MainArticle3 />
      <MainArticle4 />
      <FloatingBtn />
    </main>
  );
}
